import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-562f1d15"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { computed, ref } from "vue";
import { getIcon, Icon } from "@/assets/icons/icons";
import LoadingSpinner from "./LoadingSpinner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CoreIcon',
  props: {
    icon: {},
    label: {},
    onClick: {},
    white: { type: Boolean },
    small: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any) {



const icon = computed(() => getIcon(props.icon));
const loading = ref<boolean>(false);

const props = __props;

async function clicked() {
  if (!props.onClick || typeof props.onClick !== "function") return;
  loading.value = true;
  try {
    await props.onClick();
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (!loading.value)
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: icon.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (clicked())),
        class: _normalizeClass({
      'cursor-pointer': _ctx.onClick != undefined,
      'white-img': _ctx.white === true,
      'w-licon': !_ctx.small,
      'w-sicon': _ctx.small,
    })
      }, null, 10, _hoisted_1))
    : (_openBlock(), _createBlock(LoadingSpinner, {
        key: 1,
        class: _normalizeClass({ 'w-licon': !_ctx.small, 'w-sicon': _ctx.small })
      }, null, 8, ["class"]))
}
}

})